const context = new window.AudioContext()

export default context
